const hasColor = (ownerState)=>ownerState.color && ownerState.color !== 'inherit' && ownerState.color !== 'default';
export const get50pColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].shades['50p'] : undefined;
export const get4pColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].shades['4p'] : undefined;
export const get16pColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].shades['16p'] : undefined;
export const get30pColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].shades['30p'] : undefined;
export const get160pColor = ({ ownerState, theme })=>{
    return hasColor(ownerState) ? theme.palette[ownerState.color].shades['160p'] : undefined;
};
export const get12pColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].shades['12p'] : undefined;
export const getMainColor = ({ ownerState, theme })=>hasColor(ownerState) ? theme.palette[ownerState.color].main : undefined;
export const getDarkColor = ({ ownerState, theme })=>{
    return hasColor(ownerState) ? theme.palette[ownerState.color].dark : undefined;
};
export const getLightColor = ({ ownerState, theme })=>{
    return hasColor(ownerState) ? theme.palette[ownerState.color].light : undefined;
};
export const getContrastColor = ({ ownerState, theme })=>{
    return hasColor(ownerState) ? theme.palette[ownerState.color].contrastText : undefined;
};
export const isValidationColor = ({ ownerState })=>ownerState.color === 'error' || ownerState.color === 'warning' || ownerState.color === 'underwriting';
